import template from './dateTimeField.html';
import controller from './dateTimeField.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;
